/* app/js/src/components/calendar/calendar-grid.component.scss */
.row-marker.dark {
  color: #232f3a;
}
.cursor-pointer {
  cursor: pointer;
}
.scrollable-container::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.scrollable-container::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.scrollable-container::-webkit-scrollbar-corner {
  background: transparent;
}
.scrollable-container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.scrollable-container::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.scrollable-container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.scrollable-container::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.scrollable-container::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.scrollable-container::-webkit-scrollbar-thumb {
  border-width: 0;
}
.dark-text-small {
  color: #232f3a;
  font-size: 10px;
  letter-spacing: 0.1px;
}
.header {
  display: table;
  table-layout: fixed;
  border-collapse: collapse;
  height: 29px;
  width: 100%;
}
.header .left-cell {
  display: table-cell;
  width: 60px;
  text-align: center;
  vertical-align: bottom;
  padding-bottom: 5px;
}
.header .main-cell {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  border: 1px solid #eef2f6;
}
.header .main-cell.empty {
  border: 0px;
  vertical-align: bottom;
  padding: 0 0 5px 0;
}
.header .main-cell.empty div {
  width: 100%;
  height: 8px;
  background-color: #eef2f6;
}
.header .right-stub {
  display: table-cell;
  width: 11px;
}
.scrollable-container {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-y: scroll;
  position: relative;
  margin-top: 9px;
}
.grid-main-wrapper {
  position: relative;
}
.layer {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  position: absolute;
  top: 0;
  left: 0;
}
.layer.upper {
  top: 1px;
  overflow: hidden;
}
.layer.bottom {
  pointer-events: none;
}
.row-left-stub {
  width: 60px;
}
.row-right-stub {
  width: 11px;
}
.row-markers-container {
  position: relative;
  margin: 1px 0 0 1px;
}
.row-markers {
  position: absolute;
  width: 100%;
}
.row-marker {
  height: 60px;
  position: relative;
}
.row-marker.dark {
  background-color: #f5f9fd;
}
.row-marker.end-of-view {
  height: 16px;
}
.row-dual-marker {
  width: 100%;
}
.row-dual-marker-top {
  height: calc(60px / 2);
  border-top: 1px solid #e3e6ea;
  border-bottom: 1px dashed #e9ebee;
}
.row-dual-marker-bottom {
  position: relative;
  top: -1px;
  height: calc(60px / 2 + 2px);
}
.column-left {
  text-align: right;
  vertical-align: top;
  width: 60px;
}
.daypart-header {
  height: 60px;
}
.daypart-header-inner {
  border-top: 1px solid #e3e6ea;
  width: 70%;
  margin-left: 30%;
  padding-right: 3px;
}
.daypart-header:first-of-type .daypart-header-inner {
  width: 100%;
  margin-left: 0;
}
.daypart-header.zoom-in {
  cursor: zoom-in;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.daypart-header.zoom-in:hover {
  background-color: rgba(227, 230, 234, 0.3);
}
.daypart-header.zoom-out {
  cursor: zoom-out;
}
.column {
  border-left: 1px solid #e3e6ea;
  position: relative;
}
icn-calendar-video.video-drag {
  visibility: hidden;
}
.drag-marker {
  position: absolute;
  pointer-events: none;
  height: 2px;
  z-index: 10;
}
.drag-marker div {
  border: 1px solid #40c4ff;
  height: 100%;
  margin-right: 15px;
}
.row-marker.end-of-view .row-dual-marker.row-dual-marker-top {
  height: 16px;
}
.row-marker.end-of-view .row-dual-marker.row-dual-marker-bottom {
  display: none;
}
.daypart-header.end-of-view {
  height: 16px;
}
.current-time-triangle {
  width: 0px;
  height: 9px;
  position: absolute;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #f00;
  transform: rotate(270deg);
}
.current-time-line {
  height: 9px;
  width: 100%;
  position: absolute;
  z-index: 3;
}
.current-time-line div {
  background-color: #ff0000;
  height: 1px;
  margin-top: 3.5px;
}
/*# sourceMappingURL=calendar-grid.component.css.map */
